import React, { Component } from "react";
import { View, StyleSheet, Text, TouchableOpacity } from "react-native";
import { Data, OrdData, PosData } from "../~Utilities/Data";
import {ScrollView,  } from 'react-native-gesture-handler';
import RNPickerSelect from "react-native-picker-select";
import { Connection, ConnectionMkt, ConnectionOrd, ISettings} from "../~Utilities/Connection";
import OBNakedText from "../C_Text/OBNakedText";
import OBChange from "../C_Text/OBChange";
import OB from './OB';
import Utilities from '../~Utilities/Utilities';
import OBNakedStaticStyleText from "../C_Text/OBNakedStaticStyleText";
import { Feather, FontAwesome5, Foundation, MaterialCommunityIcons  } from '@expo/vector-icons';
import { PriceType, TransactionType } from "../~Utilities/Rq";
import { FontAwesome  } from '@expo/vector-icons';
import { AppMain, EventOrder, EvtData, EvtItem, FontInfo } from "../~Utilities/Constants";
import { TOUCHABLE_STATE } from "react-native-gesture-handler/lib/typescript/components/touchables/GenericTouchable";
import Text2 from "../C_Text/Text2";
import moment from "moment";
import QB from "./QB";
import EVTTop from "./EVTTop";
import TextWithImage from "../C_Text/TextWithImage";
import Order from "../C_Popups/SettingsAndOrders";
import Text3 from "../C_Text/Text3";
import OnlyImage from "../C_Text/OnlyImage";
import EVTInfo from "./EVTInfo";
import { getPosition } from "../C_Drag/ConfigContext";

/*   ====================================================================   */

export interface IEVTInfo
{
  oData     : Data;
  bindEvent : (onEvent    : (() => void), 
               bSubscribe : boolean) => void,
  oEvtData  : EvtData | undefined;

  qbRef?              : React.RefObject<QB>;
  visible  : boolean;
}

/*   ====================================================================   */

interface IORDState 
  {
  visible             : boolean,
  pos_data?           : PosData,
  //evt_data?           : EvtData,
  count_total         : number;
  count_working       : number;
  height              : number;
  evt_index           : number;
  //evt_strike_price?   : number;
  evt_item?           : EvtItem;
  buy_sell?           : boolean;
  // call_pos            : PosData[];
  // put_pos             : PosData[];
  }

/*   ====================================================================   */

export default class EVT extends Component<IEVTInfo>
 {
  public   iRefreshCount               = 0;

  private  oEvtData   : EvtData | undefined;
  private  bUpdateOrd : boolean = false;
  private  oCData     : Data | undefined;
  private  oPData     : Data | undefined;
  private  oEvtMap?   : Map<number, EvtItem>;
  private  oFirstSym? : Data;
  private  iCurrTime? : number;
  private  sExpiry?   : string;

  public  infoRef?    : ScrollView   | any;
  private iHeightTo   : number = 0;
  
  private dStkNear    : number | undefined;
  private iTotal      : number = 0;

  // private sSvAccount? : string;

  // private  oCallPos   : PosData[] = Array(0);
  // private  oPutPos    : PosData[] = Array(0);
  private  dStkToShow : number | undefined;
  private  bSubscribe = false;
  private  bCentered  = false;

  state : IORDState = {visible:false, 
                       pos_data:undefined, 
                       //evt_data:undefined,
                       count_total:0,
                       count_working:0, 
                       height:OB.WHITE_HEIGHT,
                       evt_index:-1
                      //  call_pos:this.oCallPos,
                      //  put_pos:this.oPutPos,
                      };

  /*   -------------------------------------------------------------------   */

  public bookRef  : ScrollView | any = null;
  //public pos_data : PosData | undefined;

  /*   -------------------------------------------------------------------   */

  constructor(props)
  {
  super(props);

  /*   -------------------------------------------------------------------   */
 
  this.Hide              = this.Hide.bind(this);
  this.Show              = this.Show.bind(this);
  this.SelectAccount     = this.SelectAccount.bind(this);
  this.GetData           = this.GetData.bind(this);
  this.UpdateData        = this.UpdateData.bind(this);

  this.Refresh           = this.Refresh.bind(this);
  this.ChangeEVT         = this.ChangeEVT.bind(this);

  this.SetInitialStrike  = this.SetInitialStrike.bind(this);
  this.Decrement         = this.Decrement.bind(this);
  this.Increment         = this.Increment.bind(this);
  this.GetEvtItem        = this.GetEvtItem.bind(this);
  this.GetStrikePrice    = this.GetStrikePrice.bind(this);
  this.GetSymbol         = this.GetSymbol.bind(this);
  this.PageTurned        = this.PageTurned.bind(this);
  this.GetStrikes        = this.GetStrikes.bind(this);
  this.SetIndex          = this.SetIndex.bind(this);
  this.PlaceBuyCall      = this.PlaceBuyCall.bind(this);
  this.PlaceBuyPut       = this.PlaceBuyPut.bind(this);
  this.CancelCall        = this.CancelCall.bind(this);
  this.CancelPut         = this.CancelPut.bind(this);
  this.UpdateFont        = this.UpdateFont.bind(this);
  this.SwitchEvtItem     = this.SwitchEvtItem.bind(this);
  this.GetMktData        = this.GetMktData.bind(this);
  this.onOrderEvent      = this.onOrderEvent.bind(this);
  this.GetPos            = this.GetPos.bind(this);
  this.HideOthers        = this.HideOthers.bind(this);

  this.scrollTo          = this.scrollTo.bind(this);
  // this.SetStkNear        = this.SetStkNear.bind(this);


  // this.GetExpiry         = this.GetExpiry.bind(this);

  // let z = Utilities.FindItem(ConnectionOrd.oSettings, this.props.oData.token);
  // let oSett : ISettings | undefined;
  
  // //alert(this.sSvAccount)
  // //Utilities.Sendlog("Saved account: " + this.sSvAccount + " " + this.props.oData.token);

  // if (z != AppMain.IMAGINARY)
  //   {
  //   oSett           = ConnectionOrd.oSettings[z];
  //   this.sSvAccount = oSett?.sAccount;
  //   }

  let oPosData          = this.GetData(this.props.oData.sv_account);
  //let oEvtData       = ConnectionMkt.GetEvtData(this.props.oData);
  //let oEvtIndex         = -1;

  this.state            = {
                          visible:this.props.visible, 
                          pos_data: oPosData,
                          //evt_data: this.props.oEvtData,
                          count_total: oPosData? 
                                      oPosData.orders.length : 0,
                          count_working: oPosData? 
                                        oPosData.orders_working.length: 0,
                          height:OB.WHITE_HEIGHT,
                          evt_index:-1,

                          //evt_item:this.GetEvtItem(oEvtIndex),
                          //evt_strike_price:this.GetStrikePrice(oEvtIndex)
                          };

  if (this.props.oEvtData          && 
      this.props.oEvtData.oEvtList && 
      this.props.oEvtData.oEvtList.size > 0)
    {
    this.oEvtData = this.props.oEvtData;
    this.oEvtMap  = new Map([...this.props.oEvtData.oEvtList].sort((a, b) => a[0] - b[0]));

    //oEvtIndex     = Math.round((this.props.oEvtData.oEvtList.size - 1)/2);
    //Utilities.Sendlog("Event setting default index ctr: " + oEvtIndex + " " + Utilities.GetKeyValueMapString(this.oEvtMap));
    this.SwitchEvtItem();
    }
  }

  /*   -------------------------------------------------------------------   */

  HideOthers(dStkToShow : number | undefined)
  {
  if (this.dStkToShow == dStkToShow)
    return;

  if (dStkToShow == undefined)
    {
    this.dStkNear = this.dStkToShow;

    if (__DEV__)
      Utilities.Sendlog("Navigate to: " + this.dStkNear);
    }

  this.dStkToShow = dStkToShow;

  this.iRefreshCount++;
  this.forceUpdate();
  }

  /*   -------------------------------------------------------------------   */

  UpdateFont()
  {
  if (this.state.height != OB.WHITE_HEIGHT)
    this.setState({height:OB.WHITE_HEIGHT});
  }

  /*   -------------------------------------------------------------------   */

  Hide()
  {
  this.setState({visible:false})
  }

  /*   -------------------------------------------------------------------   */

  Show()
  {
  if (this.state.visible == false)
    {
    this.setState({visible:true})
    }
  }

  /*   -------------------------------------------------------------------   */

  componentDidMount() 
  {
  //ConnectionOrd.BindEvent(this.onOrderEvent, true);
  this.props.bindEvent(this.UpdateData, true);

  // this.infoRef?.scrollTo({index:50, ani});

  // if (this.dStkToShow)
  //   this.infoRef?.scrollTo({y: 0, 
  //                           animated:false});


//this.iHeightTo = AppMain.IMAGINARY;


  }

  /*   -------------------------------------------------------------------   */

   componentWillUnmount() 
  {
  //ConnectionOrd.BindEvent(this.onOrderEvent, false);
  this.props.bindEvent(this.UpdateData, false);
  }

  /*   ------------------------------------------------------------------   */

  componentDidUpdate()
  {
  //Utilities.Sendlog("component did update: " + this.iHeightTo);

  // if (!this.dStkToShow)
  //   this.infoRef?.scrollTo({y: this.iHeightTo, 
  //                           animated:false});

  }

  /*   -------------------------------------------------------------------   */

  onOrderEvent (sToken     : string,
                oOrdData?  : OrdData,
                oPosData?  : PosData,
                dRemPrice? : number)
  {
  // if (!oOrdData || !oPosData)
  //   {
  //   return;  
  //   }

  // /*   -------------------------------------------------------------------   */

  // let z = Utilities.FindAny(this.oCallPos, oPosData);

  // if (z == AppMain.IMAGINARY)
  //   z = Utilities.FindAny(this.oPutPos, oPosData);

  // if (z == AppMain.IMAGINARY)
  //   return;

  // /*   -------------------------------------------------------------------   */

  // this.bUpdateOrd = true;
  }

  /*   -------------------------------------------------------------------   */

  Increment()
  {
  // if (!this.oEvtData          || 
  //     !this.oEvtData.oEvtList)
  //   return;

  // if (this.state.evt_index < this.oEvtData.oEvtList.size - 1)
  //   {
  //   Utilities.Sendlog("Event Setting Index: " + (this.state.evt_index + 1));
  //   this.setState({evt_index:this.state.evt_index + 1, 
  //                  evt_item:this.GetEvtItem(this.state.evt_index + 1),
  //                  //evt_strike_price:this.GetStrikePrice(this.state.evt_index + 1),
  //                  buy_sell:undefined});
  //   }
  }

  /*   -------------------------------------------------------------------   */

  Decrement()
  {
  // if (!this.oEvtData          || 
  //     !this.oEvtData.oEvtList ||
  //     this.state.evt_index == AppMain.IMAGINARY)
  //   return;

  // if (this.state.evt_index < this.oEvtData.oEvtList.size &&
  //     this.state.evt_index >= 1)
  //   {
  //   Utilities.Sendlog("Event Setting Index: " + (this.state.evt_index - 1));
  //   this.setState({evt_index:this.state.evt_index - 1,
  //                  evt_item:this.GetEvtItem(this.state.evt_index - 1),
  //                  //evt_strike_price:this.GetStrikePrice(this.state.evt_index - 1),
  //                  buy_sell:undefined});
  //   }
  }

  /*   -------------------------------------------------------------------   */

  GetStrikes()
  {
    let oStrikes = new Array(0);

    if (!this.oEvtMap)
      {
      return (oStrikes);
      }

    for (var [dStrike, oEvtItem] of this.oEvtMap.entries()) 
      {
      let sKey = ConnectionMkt.getFmt(dStrike, this.props.oData);

      oStrikes.push({label:sKey, value:sKey, key:sKey, color:"black"});
      }

    return(oStrikes);
  }

  /*   -------------------------------------------------------------------   */

  SetIndex(iIndex : number)
  {
  if (!this.oEvtData          || 
      !this.oEvtData.oEvtList ||
      this.state.evt_index == AppMain.IMAGINARY)
    return;

  if (this.state.evt_index != iIndex)
    {
    if (__DEV__)      
      Utilities.Sendlog("Event Setting Index: " + (iIndex));

    this.SwitchEvtItem();

    // this.setState({evt_index:iIndex,
    //                evt_item:this.GetEvtItem(iIndex),
    //                //evt_strike_price:this.GetStrikePrice(iIndex),
    //                buy_sell:undefined});
    }
  }

  /*   -------------------------------------------------------------------   */

  private SwitchEvtItem()
  {
  if (!this.oEvtMap)
    {
    if (__DEV__)      
      Utilities.Sendlog("Event Contract: evtdata undefined");

    return;
    }

  // this.oCallPos.splice(0, this.oCallPos.length);
  // this.oPutPos.splice(0, this.oPutPos.length);

  let iDelta = 0;
  let dStrikeNear : number | undefined = undefined;

  for (const oItem of this.oEvtMap.values())
    {
    if (!this.oFirstSym)
      this.oFirstSym = oItem.oCallData;


    if (this.props.oData.trade_got && this.props.oData.last != undefined)
      {
      if (dStrikeNear == undefined || iDelta > Math.abs(this.props.oData.last - oItem.dStrike))
        {
        iDelta      = Math.abs(this.props.oData.last - oItem.dStrike)
        dStrikeNear = oItem.dStrike;
        }
      }
    // if (oItem.oCallData)
    //   {
    //   let oPosData = ConnectionOrd.GetPosData(oItem.oCallData);

    //   if (oPosData)
    //     {
    //     this.oCallPos.push(oPosData);
    //     }
    //   }

    // if (oItem.oPutData)
    //   {
    //   let oPosData = ConnectionOrd.GetPosData(oItem.oPutData);

    //   if (oPosData)
    //     {
    //     this.oPutPos.push(oPosData);
    //     }
    //   }

    //ConnectionMkt.AddSymbolSubOpt(oItem.sCallToken);
    //ConnectionMkt.AddSymbolSubOpt(oItem.sPutToken);
    //Utilities.Sendlog("Event Contract: subscribed");
    }

  if (__DEV__)
    Utilities.Sendlog(this.props.oData.token + " Event Contract Stk Near: " + dStrikeNear);

  this.dStkNear = dStrikeNear;  

  // if (this.state.evt_index == iNewIndex)
  //   {
  //   Utilities.Sendlog("Event Contract: same index");
  //   return;
  //   }

  // if (this.state.evt_item)
  //   {
  //   ConnectionMkt.RemoveSymbolSubOpt(this.state.evt_item.sCallToken);
  //   ConnectionMkt.RemoveSymbolSubOpt(this.state.evt_item.sPutToken);
  //   }

  // let oEvtItem = this.GetEvtItem(iNewIndex);

  // if (oEvtItem)
  //   {
  //   this.oCData = ConnectionMkt.AddSymbolSubOpt(oEvtItem.sCallToken);
  //   this.oPData = ConnectionMkt.AddSymbolSubOpt(oEvtItem.sPutToken);
  //   }

  // this.setState({evt_index:iNewIndex, evt_item:oEvtItem});
  }

  /*   -------------------------------------------------------------------   */

  public GetMktData(bSubribe : boolean)
  {
  this.bSubscribe = bSubribe;

  /*   -------------------------------------------------------------------   */

  if (!this.oEvtMap)
    {
    if (__DEV__)      
      Utilities.Sendlog("Event Contract: evtdata undefined");

    return;
    }

  /*   -------------------------------------------------------------------   */

  if (bSubribe && this.oEvtData && !this.oEvtData.bLdRefData)
    {
    ConnectionOrd.oConn?.Rq_LoadRefData(this.oEvtData);
    }

  /*   -------------------------------------------------------------------   */

  for (const oItem of this.oEvtMap.values())
    {
    if (bSubribe)
      {
      ConnectionMkt.AddSymbolSubOpt(oItem.sCallToken);
      ConnectionMkt.AddSymbolSubOpt(oItem.sPutToken);
      //Utilities.Sendlog("Event Contract: subscribed");
      }
    else
      {
      ConnectionMkt.RemoveSymbolSubOpt(oItem.sCallToken);
      ConnectionMkt.RemoveSymbolSubOpt(oItem.sPutToken);
      //Utilities.Sendlog("Event Contract: subscribed");
      }
    }

    if (bSubribe)
      {
      if (__DEV__)        
        Utilities.Sendlog("Event Contract: subscribed " + this.props.oData.token + " " + this.oEvtMap.size);
      }
    else
      {
      if (__DEV__)        
        Utilities.Sendlog("Event Contract: un-subscribed " + this.props.oData.token);
      }
  }

  /*   -------------------------------------------------------------------   */

  // private SetStkNear()
  // {
  // if (!this.oEvtMap || this.dStkToShow)
  //   {
  //   return;
  //   }

  // let iDelta = 0;
  // let dStrikeNear : number | undefined = undefined;

  // for (const oItem of this.oEvtMap.values())
  //   {
  //   if (this.props.oData.trade_got)
  //     {
  //     if (dStrikeNear == undefined || iDelta > Math.abs(this.props.oData.last - oItem.dStrike))
  //       {
  //       iDelta      = Math.abs(this.props.oData.last - oItem.dStrike)
  //       dStrikeNear = oItem.dStrike;
  //       }
  //     }
  //   }

  
  // Utilities.Sendlog(this.props.oData.token + " Event Contract Stk Near: " + dStrikeNear);
  // this.dStkNear = dStrikeNear;
  // this.iRefreshCount++;
  // this.forceUpdate();
  // }

  /*   -------------------------------------------------------------------   */

  GetEvtItem(iEvtIndex : number)
  {
  if (!this.oEvtMap || iEvtIndex == AppMain.IMAGINARY)
    return;

  if (iEvtIndex < this.oEvtMap.size && iEvtIndex >= 0)
    {
    let iIndex = 0;

    for (var [dStrike, oEvtItem] of this.oEvtMap.entries()) 
      {
      if (iIndex == iEvtIndex)
        {
        return(oEvtItem);

        //Utilities.Sendlog("Event Strike: " + dStrike);
        //return(ConnectionMkt.getFmt(dStrike, this.props.oData));
        }

      iIndex++;
      }
    }
  }

  /*   -------------------------------------------------------------------   */

  GetStrikePriceFmt(iEvtIndex : number)
  {
  if (!this.oEvtMap || iEvtIndex == AppMain.IMAGINARY)
    {
    //return("Event Strike selected: ");
    return("");
    }

  if (iEvtIndex < this.oEvtMap.size && iEvtIndex >= 0)
    {
    let iIndex = 0;

    for (var [dStrike, oEvtItem] of this.oEvtMap.entries()) 
      {
      if (iIndex == iEvtIndex)
        {
        //return("Event Strike selected: " + dStrike);

        return( ConnectionMkt.getFmt(dStrike, this.props.oData) );
        }

      iIndex++;
      }
    }

  return("");
  }

  /*   -------------------------------------------------------------------   */

  GetStrikePrice(iEvtIndex : number)
  {
  if (!this.oEvtMap || iEvtIndex == AppMain.IMAGINARY)
    {
    //return("Event Strike selected: ");
    return;
    }

  if (iEvtIndex < this.oEvtMap.size && iEvtIndex >= 0)
    {
    let iIndex = 0;

    for (var [dStrike, oEvtItem] of this.oEvtMap.entries()) 
      {
      if (iIndex == iEvtIndex)
        {
        //return("Event Strike selected: " + dStrike);

        return( dStrike );
        }

      iIndex++;
      }
    }

  return;
  }

  /*   -------------------------------------------------------------------   */

  PageTurned()
  {
  this.setState({buy_sell:undefined});
  this.forceUpdate();
  }

  /*   -------------------------------------------------------------------   */

  ChangeEVT(oEvtData : EvtData)
  {
  this.dStkToShow = undefined;

  if (this.oEvtData)
    {
    this.GetMktData(false);
    this.oEvtData  = undefined;
    this.bCentered = false;
    //this.iHeightTo = 0;
    }

  this.Refresh(oEvtData);    
  }

  /*   -------------------------------------------------------------------   */

  Refresh(oEvtData? : EvtData | undefined)
  {
  if (!this.oEvtData)
    {
    if (oEvtData)
      {
      let oEvtIndex = -1;

      if (oEvtData               && 
          oEvtData.oEvtList      && 
          oEvtData.oEvtList.size > 0)
        {
        oEvtIndex = Math.round(oEvtData.oEvtList.size/2);

        this.oEvtData = oEvtData;
        this.oEvtMap  = new Map([...oEvtData.oEvtList].sort((a, b) => a[0] - b[0]));

        if (__DEV__)
          Utilities.Sendlog("Event Contract: Event setting default index rfsh: " + oEvtIndex +  " " + Utilities.GetKeyValueMapString(this.oEvtMap));

        this.SwitchEvtItem();

        //New_EVT
        this.forceUpdate();
        
        if (this.bSubscribe)
          this.GetMktData(true);

        //this.SwitchEvtItem(oEvtIndex);

        // this.setState({evt_index:oEvtIndex,
        //                evt_item:this.GetEvtItem(oEvtIndex)}
        //                //evt_strike_price:this.GetStrikePrice(oEvtIndex),}
        //                );
        }

      //Utilities.GetKeyValueString
      }
    // else
    //   {
    //   oEvtData = ConnectionMkt.GetEvtData(this.props.oData);

    //   if (oEvtData)
    //     this.setState({evt_data:oEvtData});
    //   }
    }

    // if (!this.dStkToShow)
    //   this.infoRef?.scrollTo({y: this.iHeightTo, 
    //                           animated:false});
  }

  /*   -------------------------------------------------------------------   */



  /*   -------------------------------------------------------------------   */  

  SetInitialStrike()
  {
  if (this.oEvtData && this.state.evt_index == AppMain.IMAGINARY)
    {
      {
      if (this.oEvtData.oEvtList      && 
          this.oEvtData.oEvtList.size > 0)
        {
        let oEvtIndex = Math.round(this.oEvtData.oEvtList.size/2);
        this.oEvtMap  = new Map([...this.oEvtData.oEvtList].sort((a, b) => a[0] - b[0]));

        if (__DEV__)
          Utilities.Sendlog("Event setting default index scrl: " + oEvtIndex);

        //this.setState({evt_index:oEvtIndex});
        this.SwitchEvtItem();
        }
      }
    }
  }

  /*   -------------------------------------------------------------------   */  

  GetData(sAccKey : string = "")
  {
    if (Connection.oAccStore.size > 0)
      {
      let acckey : string;

      if (sAccKey && Connection.oAccStore.has(sAccKey))
        acckey = sAccKey;
      else
        acckey = Connection.oAccStore.keys().next().value;

      // let acckey = sAccKey;

      // if (!acckey)
      //   acckey = Connection.oAccStore.keys().next().value;

      let token   = "";

      if (this.props.oData.trading_symbol && this.props.oData.trading_exchange)
        token = this.props.oData.trading_symbol + "." + this.props.oData.trading_exchange;
      else
        token = this.props.oData.token;

      let key = acckey + token;

      //alert(key);
       
       let data1 = Connection.oPosStore.get(key);

       if (data1 == undefined)
        {
        //Utilities.Sendlog("New Pos: " + acckey + " token: " + token);

        data1 = new PosData(acckey, token);
        Connection.oPosStore.set(key, data1);
        }

       //alert(key + data1?.net_qty);

       return(data1);
      }
    // else
    //   Utilities.Sendlog("account size is 0");
  }

  /*   -------------------------------------------------------------------   */

  SelectAccount(oData : PosData)
  {
  this.setState({pos_data: oData, }); 

  //this.pos_data = oData;  
  if (__DEV__)  
    Utilities.Sendlog("******************** Event Setting account: " + oData?.token + " " + oData?.acc_key);

  this.forceUpdate();
  }

  /*   -------------------------------------------------------------------   */

  UpdateData()
  {
  // if (this.bCentered == false && this.iHeightTo > 0)
  //   {
  //     this.infoRef?.scrollTo({y: this.iHeightTo, 
  //                             animated:false});
  //     this.bCentered = true;

  //     this.iHeightTo = AppMain.IMAGINARY;
  //   }

  if (Connection.oAccStore.size > 0 && 
      this.state.pos_data         == undefined)
      {
      let oData = this.GetData(this.props.oData.sv_account);

      if (oData != null)
        this.SelectAccount(oData);
      }

  // if (this.state.pos_data != undefined)
  //   {
  //   if (this.state.pos_data.orders_working.length != this.state.count_working ||
  //       this.state.pos_data.orders.length         != this.state.count_total)
  //     this.setState({count_total: this.state.pos_data.orders.length,
  //                    count_working: this.state.pos_data.orders_working.length}); 
  //   }
    //if (this.state.)

    if (this.bUpdateOrd == true)
      {
      this.forceUpdate();
      this.bUpdateOrd = false;
      }
  }

  /*   ------------------------------------------------------------------   */

  GetSymbol()
  {
  let str = " ";

  if (this.state.buy_sell == undefined || !this.state.evt_item)
    return(" ");

  if (this.state.buy_sell==true)
    {
    str += "Buy " + this.state.evt_item.sCallToken + " @Market";
    }
  else if (this.state.buy_sell==false)
    {
    str += "Buy " + this.state.evt_item.sPutToken + " @Market";
    }

    return(str);
  }

  /*   ------------------------------------------------------------------   */

  PlaceBuyCall(oEvtItem : EvtItem)
  {
  if (Connection.IsOrderAvailable() == false)
    {
    this.props.qbRef?.current?.oOrderRef?.ShowNoOrder();  
    return;
    }

  if (oEvtItem.sCallToken)
    {
    oEvtItem.iCallBuys++;
    oEvtItem.oOrders.unshift(new EventOrder(oEvtItem.dStrike, true));

    ConnectionOrd.oConn?.Rq_PlaceOrder(this.state.pos_data?.acc_key, 
                                       oEvtItem.sCallToken, 
                                       TransactionType.BUY, 
                                       1, 
                                       "Event Trade, Thumb Down Button",
                                       PriceType.MARKET);
    }

  this.forceUpdate();    
  }

  /*   ------------------------------------------------------------------   */

  PlaceBuyPut(oEvtItem : EvtItem)
  {
  if (Connection.IsOrderAvailable() == false)
    {
    this.props.qbRef?.current?.oOrderRef?.ShowNoOrder();  
    return;
    }

  if (oEvtItem.sPutToken)
    {
    oEvtItem.iPutBuys++;
    oEvtItem.oOrders.unshift(new EventOrder(oEvtItem.dStrike, false));

    ConnectionOrd.oConn?.Rq_PlaceOrder(this.state.pos_data?.acc_key, 
                                       oEvtItem.sPutToken, 
                                       TransactionType.BUY, 
                                       1, 
                                       "Event Trade, Thumb Up Button",
                                       PriceType.MARKET);
    }

  this.forceUpdate();    
  }

  /*   ------------------------------------------------------------------   */

  CancelCall(oEvtItem : EvtItem,
             iIndex   : number)
  {
  // Utilities.Sendlog("Event Exiting : " + oEvtItem.sCallToken);

  // if (oEvtItem)
  //   {
  //   oEvtItem.iCallBuys = 0;

  //   let oPos = this.oCallPos[iIndex];

  //   if (oPos && oPos.net_qty && oEvtItem.sCallToken)
  //     ConnectionOrd.oConn?.Rq_PlaceOrder(this.state.pos_data?.acc_key, 
  //                                        oEvtItem.sCallToken, 
  //                                        oPos.net_qty < 0? TransactionType.BUY : TransactionType.SELL, 
  //                                        Math.abs(oPos.net_qty),
  //                                        PriceType.MARKET);

  //   //this.forceUpdate();
  //   }
  }

  /*   ------------------------------------------------------------------   */ 

  CancelPut(oEvtItem : EvtItem,
            iIndex   : number)
  {
  // Utilities.Sendlog("Event Exiting : " + oEvtItem.sPutToken);

  // if (oEvtItem)
  //   {
  //   oEvtItem.iPutBuys = 0;

  //   let oPos = this.oPutPos[iIndex];

  //   if (oPos && oPos.net_qty && oEvtItem.sPutToken)
  //     ConnectionOrd.oConn?.Rq_PlaceOrder(this.state.pos_data?.acc_key, 
  //                                        oEvtItem.sPutToken, 
  //                                        oPos.net_qty < 0? TransactionType.BUY : TransactionType.SELL, 
  //                                        Math.abs(oPos.net_qty),
  //                                        PriceType.MARKET);

  //   //this.forceUpdate();
  //   }
  }

  /*   ------------------------------------------------------------------   */ 

  // GetExpiry()
  // {
  // if (!this.iExpiry)
  //   return(this.sExpiry);

  // let iTm = Date.now();

  // if (iTm == this.iCurrTime)
  //   return(this.sExpiry);
  // else
  //   this.iCurrTime = iTm;



  // iTm = this.iExpiry - Math.trunc(iTm/1000);

  // if (iTm < 0)
  //   {
  //   this.sExpiry = "Expired";
  //   return(this.sExpiry);
  //   }

  // let iHrs = Math.trunc(iTm/3600)
  // iTm -= iHrs * 3600;

  // let iMins = Math.trunc(iTm/60)
  // iTm -= iMins * 60;

  // this.sExpiry = "Expires in " + 
  //                 iHrs.toFixed() + ":" + 
  //                 EVT.FmtNumber(iMins) + ":" + 
  //                 EVT.FmtNumber(iTm);

  // return(this.sExpiry);
  // }

  /*   ------------------------------------------------------------------   */

  static GetExpiryFmt(iExpiry : number)
  {
  // Utilities.formatTimeFromSsboe(iExpiry, ""); 
  }

  /*   ------------------------------------------------------------------   */

  static FmtNumber(iNum : number)
  {
  if (iNum < 10)
    return("0" + iNum.toFixed());
  else
    return(iNum.toFixed());
  }

  /*   ------------------------------------------------------------------   */

  static GetExitPosColor(oPos   : PosData[], 
                         iIndex : number)
  {
    if (oPos[iIndex]          == undefined ||
        oPos[iIndex]?.net_qty == undefined ||
        oPos[iIndex]?.net_qty == 0)
      return('gainsboro');
    else
      return('#ff355e');
  }

  /*   ---------------------------------------------------------------------   */

  static GetPutPosColor(oPos   : PosData[], 
                        iIndex : number)
  {
    if (oPos[iIndex]          == undefined ||
        oPos[iIndex]?.net_qty == undefined ||
        oPos[iIndex]?.net_qty == 0)
      return('gainsboro');
    else
      return('hotpink');
  }

  /*   ---------------------------------------------------------------------   */

  static GetCallPosColor(oPos   : PosData[], 
                         iIndex : number)
  {
    if (oPos[iIndex]          == undefined ||
        oPos[iIndex]?.net_qty == undefined ||
        oPos[iIndex]?.net_qty == 0)
      return('gainsboro');
    else
      return('dodgerblue');
  }

  /*   ---------------------------------------------------------------------   */

  static GetPosText(oPos     : PosData[], 
                    iIndex   : number)
  {
  if (!oPos[iIndex])
    return;

  if (oPos[iIndex]?.net_qty ||
      oPos[iIndex]?.closed_pnl)
    return(oPos[iIndex]?.net_qty);
  else
    return("");
  }

  /*   ---------------------------------------------------------------------   */

  GetPos(oPosData: PosData[],
         iIndex  : number)
  {
  if (__DEV__)    
    Utilities.Sendlog(this.props.oData.token + " ***** Event Pos " + oPosData?.length + " index: " + iIndex + " " + oPosData[iIndex]?.token);

  return(oPosData? oPosData[iIndex] : undefined);
  }

  /*   ---------------------------------------------------------------------   */

  static GetPNLText(oPos     : PosData[], 
                    iIndex   : number,
                    iPnlType : number | undefined)
  {
    //return("2.40");

    if (!oPos[iIndex])
      return;

    //this.state.qbRef?.current?.oOrderRef?.state.pnl_type
    switch(iPnlType)
    {
    case Order.PNL_AUTO:
    default:  
      if (oPos[iIndex].net_qty)
        return(oPos[iIndex]?.open_pnl);
      else
        return(oPos[iIndex]?.total_pnl);

    case Order.PNL_OPEN:
      return(oPos[iIndex]?.open_pnl);

    case Order.PNL_TOTAL:
      return(oPos[iIndex]?.total_pnl);

    case Order.PNL_OFF:
      return;
    }
  }

  /*   ---------------------------------------------------------------------   */

  static GetPNLColor(oPos     : PosData[], 
                     iIndex   : number,
                     iPnlType : number | undefined)
  {
  let iPnl : number | undefined;

  if (!oPos[iIndex])
    return;

  switch(iPnlType)
    {
    case Order.PNL_AUTO:  
    default:
      if (oPos[iIndex]?.net_qty != undefined &&
          oPos[iIndex]?.net_qty != 0)
        {
        iPnl = oPos[iIndex]?.open_pnl;

        if (iPnl == undefined)
          return('gainsboro')
        else if (iPnl >= 0)
          return(FontInfo.sGreen)
        else
          return('red')
        }
      else
        {
        iPnl = oPos[iIndex]?.total_pnl;

        if (iPnl == undefined || !iPnl)
          return('gainsboro')
        else if (iPnl >= 0)
          return(FontInfo.sGreen)
        else
          return('red')
        }
      
    case Order.PNL_OPEN:
        iPnl = oPos[iIndex]?.open_pnl;

        if (iPnl == undefined || !iPnl)
          return('gainsboro')
        else if (iPnl >= 0)
          return(FontInfo.sGreen)
        else
          return('red')

    case Order.PNL_TOTAL:
        iPnl = oPos[iIndex]?.total_pnl;

        if (iPnl == undefined || !iPnl)
          return('gainsboro')
        else if (iPnl >= 0)
          return(FontInfo.sGreen)
        else
          return('red')  
          
    case Order.PNL_OFF:
      return('gainsboro')
    }
  }

  /*   ---------------------------------------------------------------------   */

  /*   ---------------------------------------------------------------------   */

  async scrollTo()
  {
    this.infoRef?.scrollTo({y: this.iHeightTo,
                            animated:false});

    this.iHeightTo = 0;
    this.iTotal    = 0;

  }

  /*   ---------------------------------------------------------------------   */

  render() 
  {
    this.iHeightTo = 0;
    this.iTotal    = 0

    if (this.state.visible == false)
      return(null);
    else  
    return (
      
      <View style={{ backgroundColor: "transparent", flex: 1, width: Utilities.WIDTH }}>

      <View style={[styles.container, {height:this.state.height,}]}>

       <View style={{width:'100%', alignSelf:'center', paddingRight:ConnectionMkt.DEVICE_NAME == ConnectionMkt.DEVICE_WEB? 15 : 0, marginBottom:2, alignItems:'center', flexDirection:'column'}}>

        {/* <View style={{flexDirection:'row'}}>

            <View style={{width:'10%'}}></View> */}
            
            <Text style={[FontInfo.appStyles.txt_normal, {textAlign:'center',
                          marginHorizontal:15, alignSelf:'center', color:'gray', marginVertical:-2}]} >{this.props.oData.trading_symbol?this.props.oData.trading_symbol:this.props.oData.symbol}.{this.props.oData.exchange} 
            </Text>


        {/* </View> */}

        <View style={{alignSelf:'center', flexDirection:'row'}}>
        
        <Feather name="arrow-down" size={14} color="gray"/>
        <OBNakedStaticStyleText
                    bindEvent={this.props.bindEvent} 
                    style={[FontInfo.appStyles.txt_normal, {marginLeft:-5, color: 'gray',}]} 
                    getText={()=>{return(!this.props.oData.low? "" : ConnectionMkt.getFmt(this.props.oData.low, this.props.oData))}}
                    />

        {/* <View style={{backgroundColor:'transparent', flexDirection:'row'}}> */}
          {/* <TouchableOpacity
           onPress={()=>{this.SetStkNear()}}> */}
          <OBNakedText
            bindEvent={this.props.bindEvent} 
            getStyle={()=>{return(this.props.oData.pc >= 0? 
                    [FontInfo.appStyles.txt_bold, {color:FontInfo.sGreen}] : [FontInfo.appStyles.txt_bold, styles.title_small_red])}} 
            getText={()=>{return(ConnectionMkt.getFmt(this.props.oData.last, this.props.oData))}}
            />
          {/* </TouchableOpacity> */}

          {/* <OBChange 
            bindEvent={this.props.bindEvent} 
            getStyle={()=>{return(this.props.oData.pc >= 0? 
                    [FontInfo.appStyles.txt_bold, styles.title_small_green_bg, {marginLeft:2, backgroundColor:FontInfo.sGreen}] : [FontInfo.appStyles.txt_bold, styles.title_small_red_bg, {marginLeft:2, }])}} 
            style={[FontInfo.appStyles.txt_bold, styles.title_small_text]}
            getText={()=>{return(this.props.oData.nc < 0? ConnectionMkt.getFmt(this.props.oData.nc, this.props.oData) : "+" + ConnectionMkt.getFmt(this.props.oData.nc, this.props.oData))}}
            />

          <Text3 name = "" bbb={this.props.bindEvent} 
            getstyle={()=>{return(this.props.oData.pc >= 0? 
              [FontInfo.appStyles.txt_bold, {marginLeft:2, color: FontInfo.sGreen,}] : [FontInfo.appStyles.txt_bold, {marginLeft:2, color: 'red'}]
              )} } 
            ggg={()=>{return(this.props.oData.pc < 0? this.props.oData.pc.toFixed(2) + "%" : "+" + this.props.oData.pc.toFixed(2) + "%")}}>
          </Text3>
        </View> */}

        <OBNakedStaticStyleText
                    bindEvent={this.props.bindEvent} 
                    style={[FontInfo.appStyles.txt_normal, {marginRight:-5, color: 'gray',}]} 
                    getText={()=>{return(!this.props.oData.high? "" : ConnectionMkt.getFmt(this.props.oData.high, this.props.oData))}}
                    />                    
        <Feather name="arrow-up" size={14} color="gray" />
        </View>


        {/* <View style={{backgroundColor:'transparent', width:'100%', flexDirection:'row'}}> */}

        {/* <View style={{flex:1, backgroundColor:'yellow'}}></View> */}
        <View style={{backgroundColor:'transparent', flexDirection:'row', width:'100%'}}>
          <View style={{width:'10%', backgroundColor:'transparent'}}></View>
          {/* <OBNakedText
            bindEvent={this.props.bindEvent} 
            getStyle={()=>{return(this.props.oData.pc >= 0? 
                    [FontInfo.appStyles.txt_bold, {color:FontInfo.sGreen}] : [FontInfo.appStyles.txt_bold, styles.title_small_red])}} 
            getText={()=>{return(ConnectionMkt.getFmt(this.props.oData.last, this.props.oData))}}
            /> */}

          {/* <View */}
           {/* onPress={()=>{this.SetStkNear()}} */}
           {/* > */}
           <View style={{width:'80%', flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
              <View style={{flexDirection:'row'}}>
                <OBChange 
                  bindEvent={this.props.bindEvent} 
                  getStyle={()=>{return(this.props.oData.pc >= 0? 
                          [FontInfo.appStyles.txt_bold, styles.title_small_green_bg, {marginLeft:0, backgroundColor:FontInfo.sGreen}] : [FontInfo.appStyles.txt_bold, styles.title_small_red_bg, {marginLeft:0, }])}} 
                  style={[FontInfo.appStyles.txt_bold, styles.title_small_text]}
                  getText={()=>{return(this.props.oData.nc < 0? ConnectionMkt.getFmt(this.props.oData.nc, this.props.oData) : "+" + ConnectionMkt.getFmt(this.props.oData.nc, this.props.oData))}}
                  />
                {/* </View> */}

                <Text3 name = "" bbb={this.props.bindEvent} 
                  getstyle={()=>{return(this.props.oData.pc >= 0? 
                    [FontInfo.appStyles.txt_bold, {marginLeft:2, color: FontInfo.sGreen,}] : [FontInfo.appStyles.txt_bold, {marginLeft:2, color: 'red'}]
                    )} } 
                  ggg={()=>{return(this.props.oData.pc < 0? this.props.oData.pc.toFixed(2) + "%" : "+" + this.props.oData.pc.toFixed(2) + "%")}}>
                </Text3>
            </View>
          </View>

          <View style={{width:'10%', alignItems:'center', justifyContent:'center',backgroundColor:'transparent'}}>
            <TouchableOpacity style={{marginRight:4, marginBottom:2, width:20, height:20, borderRadius:10, borderWidth:1, borderColor:'rgba(112,128,144,.2)', alignItems:'center', justifyContent:'center'}}  
            onPress={()=>
                {
                this.props.qbRef?.current?.oOrderRef?.ShowNoOrder("Max Profit is based upon the difference between the maximum settlement price of the contract you have purchased or are about to purchase ($100.00) and the price at which you purchased that contract. It does not take into account the costs of trading such as exchange fees, commissions, regulatory fees, etc. Your actual net profit may differ from the max profit displayed.", 
                                                                  [FontInfo.appStyles.txt_normal, {textAlign:'center', fontSize:FontInfo.iFontSize, color:FontInfo.sForeground}]);  
                }}>
              <Text style={[FontInfo.appStyles.txt_normal, {fontSize:FontInfo.iFontSize, color:'gray'}]}>i</Text>
            </TouchableOpacity>
            </View>

        </View>

        {/* <View style={{flex:1, backgroundColor:'purple'}}></View> */}
        {/* </View> */}

       </View>

       {/* Evt Data */}

      {/* <View style={{alignSelf:'center'}}><Text>{this.props.oData.evt_exp?.length + " " + this.props.oData.evt_index}</Text></View> */}
      <EVTTop oData={this.props.oData} oEVT={this}/>

       <ScrollView nestedScrollEnabled ref={node => { this.infoRef = node}} 
                  contentOffset={{x:0, y:0}}
                  contentContainerStyle={{backgroundColor:'transparent', alignItems:'center', justifyContent:'center'}}>


       {
        
       Array.from(this.oEvtMap? this.oEvtMap?.values() : new Array(0)).map((oEvtItem : EvtItem, iIndex: number, oItems : any[])=>
        {
          if (!oEvtItem) 
            return(null);

          if (this.dStkToShow && this.dStkToShow!=oEvtItem.dStrike)
            return(null);

          return(
            <View 
              key={oEvtItem.dStrike + "-" + this.state.pos_data?.acc_key + "-" + this.iRefreshCount}

              style={{alignItems:'center', backgroundColor:'transparent',}}

              onLayout={(event) => {
                var {x, y, width, height} = event.nativeEvent.layout;
      
                if (this.dStkToShow)
                  {
                  this.infoRef?.scrollTo({y: 0, 
                                          animated:false});
                  return;
                  }

                if (this.dStkNear)
                  {
                  if (oEvtItem.dStrike < this.dStkNear)
                    {
                    this.iHeightTo += height;

                    if (__DEV__)
                      Utilities.Sendlog("render: " + this.iHeightTo);
                    }
                  else
                    {
                    //if (!this.dStkToShow)
                      // this.infoRef?.scrollTo({y: this.iHeightTo, 
                      //                         animated:true});

                    //this.iHeightTo = AppMain.IMAGINARY;
                    }
                  }

                this.iTotal++;

                if (this.iTotal >= oItems.length)
                  {
                  // this.infoRef?.scrollTo({y: this.iHeightTo < 11? this.iHeightTo : this.iHeightTo - 10,
                  //                         animated:false});

                  // this.infoRef?.scrollTo({y: this.iHeightTo,
                  //                         animated:false});

                  // this.iHeightTo = 0;
                  // this.iTotal    = 0;
                  this.scrollTo();
                  }
                // else
                //   Utilities.Sendlog(this.props.oData.token + " Event Contract Stk Near height: " + this.iHeightTo);
              }}>
    
            <EVTInfo 
                     oData={this.props.oData} 
                     oPosData={this.state.pos_data} 
                     bindEvent={this.props.bindEvent}

                     qbRef={this.props.qbRef}

                     oEvtItem={oEvtItem}

                     HideOthers={this.HideOthers}
                     bExclusive={this.dStkToShow? this.dStkToShow==oEvtItem.dStrike : false}
                     //GetCallPos={()=>{ return(this.GetPos(this.state.call_pos, iIndex)) }}
                     //GetPutPos={()=>{ return(this.GetPos(this.state.put_pos, iIndex)) }}
            />
            </View>
          );
        })
        }

        {/* <View style={{alignSelf:'center', flexDirection:'row', width:Utilities.WIDTH - 50, margin:0, padding:0, alignItems:'center', 
                      alignContent:'center', justifyContent:'center',
                      backgroundColor:FontInfo.sButton, borderRadius:10, paddingVertical:10, marginTop:20, marginBottom:5,}}>

        <TouchableOpacity style={{alignItems:'center', justifyContent:'center', borderBottomLeftRadius:10, borderTopLeftRadius:10, position:'absolute', backgroundColor:FontInfo.sDivider, top:0, left:0, bottom:0, width:30}} 
                    onPress={()=>{this.CancelAll()}}>
                   <FontAwesome style={{marginLeft:2}} name="close" size={20} color={this.state.evt_item && this.state.evt_item.iPutBuys + this.state.evt_item.iCallBuys? '#ff355e' : 'gray'} />
                  </TouchableOpacity>

         <View style={{alignSelf:'center', flexDirection:'row'}}>
          <View style={{flexDirection:'row', marginRight:40}}>
          <MaterialCommunityIcons name="thumb-up" size={14} color={this.state.evt_item && this.state.evt_item.iCallBuys? 'dodgerblue' : 'gray'} />
          <Text style={[FontInfo.appStyles.txt_bold, {color:this.state.evt_item && this.state.evt_item.iCallBuys? 'dodgerblue' : 'gray'}]}>{this.state.evt_item? this.state.evt_item.iCallBuys : 0}</Text>
          </View>

          <View style={{flexDirection:'row', }}>
          <Text style={[FontInfo.appStyles.txt_bold, {color:this.state.evt_item && this.state.evt_item.iPutBuys? 'hotpink' : 'gray'}]}>{this.state.evt_item? this.state.evt_item.iPutBuys : 0}</Text>
          <MaterialCommunityIcons name="thumb-down" size={14} color={this.state.evt_item && this.state.evt_item.iPutBuys? 'hotpink' : 'gray'} />
          </View>
         </View>

        </View> */}


      {/* <View style={{alignSelf:'center', flexDirection:'row', width:200, margin:10, padding:8, marginTop:5, alignItems:'center', justifyContent:'center', backgroundColor:FontInfo.sButton, borderRadius:10}}>
      <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, fontSize:FontInfo.iFontSize + 2, minWidth:10, marginLeft:10, textAlign:'center', backgroundColor:'transparent' }]}>Orders</Text>

      <View style={{alignSelf:'center', backgroundColor:'grey', marginLeft:10, borderRadius:5}}>
      <Text style={[FontInfo.appStyles.txt_bold, {color:'white', paddingHorizontal:4}]}>{this.oEvtData? this.oEvtData?.oOrders.length : "0"}</Text>
      </View>
      </View> */}
        
      {/* {
      this.oEvtData?.oOrders.map((oEventOrder)=>
        {
          return(
          <View style={{alignSelf:'center', flexDirection:'row', width:Utilities.WIDTH - 50, margin:5, padding:8, alignItems:'center', justifyContent:'center', backgroundColor:FontInfo.sButton, borderRadius:10}}>
            <View style={{alignSelf:'center', flexDirection:'row', borderRadius:10, alignItems:'center', backgroundColor:'transparent'}}>
              <Text style={[FontInfo.appStyles.txt_bold, {color:oEventOrder.bUp? 'gray' : 'gray', marginHorizontal:5}]}> Will {this.oEvtData?.sUSymbol} settle above {ConnectionMkt.getFmt(oEventOrder.dStrike, this.props.oData)}?</Text>
              <MaterialCommunityIcons name={oEventOrder.bUp? "thumb-up" : "thumb-down"} size={14} color={oEventOrder.bUp? 'dodgerblue' : 'hotpink'} />
            </View>
          </View>
          );

        })
      } */}


      {/* <ScrollView contentContainerStyle={{backgroundColor:'transparent', alignItems:'center', justifyContent:'center'}}>

        <View style={{flexDirection:'column', width:200, margin:10, padding:8, alignItems:'center', 
                      backgroundColor:FontInfo.sButton, borderRadius:10}}>
        
        <Text style={[FontInfo.appStyles.txt_bold, 
                      {fontSize:FontInfo.iFontSize+10, color:FontInfo.sForeground, 
                      textAlign:'center'}]}>Will S&P 500 close above</Text>

        <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, 
                      textAlign:'center'}]}>5300.50?</Text>

        </View>

      </ScrollView> */}

      </ScrollView>

      </View>
      </View>
    );
  }
}

/*   ---------------------------------------------------------------------   */

function GetPickerStyles()
{
return(

  StyleSheet.create({

    inputWeb: {
      alignSelf:'center',
      fontFamily: FontInfo.iFont >= 0? FontInfo.Fonts[FontInfo.iFont].bold : undefined,
      fontSize: FontInfo.iFontSize + 0,
      //fontWeight:'bold',
      //paddingVertical: 12,
      //paddingLeft: 40,
  
      // marginLeft:5,
      //width:200,
      //marginVertical:20,
      paddingLeft: 10,
      marginTop:10,
      height:40,
      //width:100,
      textAlign:'center',


      marginHorizontal:14,
      marginBottom:8,
      borderWidth: 1,
      borderColor: FontInfo.sBorder,
      borderRadius: 10,
  
      // borderWidth: 1,
      // borderColor: '#EEEEEE',
      // borderRadius: 4,
      // borderBottomWidth:0,
      // borderBottomColor:'#EEEEEE',
      // borderBottomEndRadius:0,
      // borderBottomStartRadius:0,
  
  
      backgroundColor:'transparent',
      color: FontInfo.sForeground,
      paddingRight: 10, // to ensure the text is never behind the icon
    },
  
    inputIOS: {
      alignSelf:'center',
      fontFamily: FontInfo.iFont >= 0? FontInfo.Fonts[FontInfo.iFont].bold : undefined,
      fontSize: FontInfo.iFontSize + 4,
      //fontWeight:'bold',
      //paddingVertical: 12,
  
  
      //marginVertical:20,
      // marginLeft:5,
      paddingLeft: 10,
      marginTop:10,
      height:40,
      //width:225,
      textAlign:'center',
  
      marginHorizontal: FontInfo.iFontSize + 4,
      marginBottom:8,
      borderWidth: 1,
      borderColor: FontInfo.sBorder,
      borderRadius: 10,
      // borderBottomWidth:0,
      // borderBottomColor:'#EEEEEE',
      // borderBottomEndRadius:0,
      // borderBottomStartRadius:0,
  
      backgroundColor:'transparent',
      color: FontInfo.sForeground,
      paddingRight: 10, // to ensure the text is never behind the icon
    },
    inputAndroid: {
      alignSelf:'center',
      fontFamily: FontInfo.iFont >= 0? FontInfo.Fonts[FontInfo.iFont].bold : undefined,
      // alignSelf:'center',
      fontSize: FontInfo.iFontSize + 4,
      //fontWeight:'bold',
      // paddingLeft: 20,
      //paddingVertical: 12,
      //paddingLeft: 30,
  
      //marginVertical:20,
  
      // marginLeft:5,
      paddingLeft: 10,
      marginTop:10,
      height:40,
      //width:225,
      textAlign:'center',
  
      marginHorizontal:14,
      marginBottom:8,
      borderWidth: 1,
      borderColor: FontInfo.sBorder,
      borderRadius: 10,
  
      // borderWidth: 0,
      // borderBottomWidth:0,
      // borderBottomColor:'#EEEEEE',
      // borderBottomEndRadius:0,
      // borderBottomStartRadius:0,
      // textAlign:'center',
      // borderWidth: 0.5,
      // borderColor: 'purple',
      // borderRadius: 8,
      backgroundColor:'transparent',
      color: FontInfo.sForeground,
      paddingRight: 10, // to ensure the text is never behind the icon
    },
  
    // button_order:
    // {
    //   backgroundColor:'#f5f6fa',
    //   margin:10,
    //   padding:8,
    //   borderRadius:10,
    //   minWidth:90,
    // },
  
    // text_order:
    // {
    // alignSelf:'center',
    // fontWeight:'bold',
    // color:'red'
    // },
  
  })  

);  
}

const styles = StyleSheet.create({
  container: {
    marginTop: 4,
    backgroundColor: 'transparent',
  },

  listItem: {
    flex: 1,
    backgroundColor: 'transparent',
    justifyContent: 'center',
    paddingLeft: 0,
  },

  title_small_green: {
    color: 'green',
  },  

  title_small_red: {
    color: 'red',
  },

  title_small_green_bg: {
    backgroundColor: 'green',

    borderRadius: 4,  
    paddingRight:2,
  },  

  title_small_red_bg: {
    backgroundColor: 'red',

    borderRadius: 4,
    paddingRight:2,
  },

  title_small_text: {
    marginLeft:4,
    color: 'white',
    backgroundColor: 'transparent',
  },  
  
});

